interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  /** Icone da tela, o mesmo do menu lateral - e o que situa quem chegou. */
  icon?: React.ReactNode;
}

export function PageHeader({ title, description, actions, icon }: PageHeaderProps) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div className="flex min-w-0 items-start gap-3">
        {icon ? (
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary [&_svg]:h-5 [&_svg]:w-5">
            {icon}
          </span>
        ) : null}
        <div className="min-w-0">
          <h1 className="text-xl font-semibold tracking-tight sm:text-2xl">{title}</h1>
          {/* A frase de apoio some no celular: ela explica a tela para quem
              chega, mas ocupa duas linhas antes do conteudo em toda tela do
              sistema - e o titulo ja diz onde se esta. */}
          {description ? (
            <p className="mt-1 hidden text-sm text-muted-foreground sm:block">{description}</p>
          ) : null}
        </div>
      </div>
      {/* As acoes quebram de linha no celular: com tres botoes (imprimir,
          PDF, CSV) a linha passava da tela e o ultimo ficava cortado, fora
          de alcance - o `overflow-x-clip` da casca nem deixa rolar ate ele. */}
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  );
}
